var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerifiedToken = function SvgVerifiedToken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.522 2.624a2 2 0 0 1 2.957 0l1.02 1.12a2 2 0 0 0 1.572.651l1.514-.07a2 2 0 0 1 2.091 2.09l-.07 1.514a2 2 0 0 0 .65 1.572l1.12 1.02a2 2 0 0 1 0 2.958l-1.12 1.02a2 2 0 0 0-.65 1.572l.07 1.514a2 2 0 0 1-2.091 2.091l-1.514-.07a2 2 0 0 0-1.572.65l-1.02 1.12a2 2 0 0 1-2.957 0l-1.02-1.12a2 2 0 0 0-1.573-.65l-1.513.07a2 2 0 0 1-2.091-2.091l.07-1.514a2 2 0 0 0-.65-1.572l-1.121-1.02a2 2 0 0 1 0-2.957l1.12-1.02a2 2 0 0 0 .651-1.573l-.07-1.513a2 2 0 0 1 2.09-2.091l1.514.07a2 2 0 0 0 1.572-.65l1.02-1.121Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9 12 2 2 4-4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgVerifiedToken;